package world.phantasmal.psolib.fileFormats.quest

import world.phantasmal.psolib.Episode

private val EP_AND_NAME_TO_NPC_TYPE: Map<Pair<String, Episode>, NpcType> =
    mutableMapOf<Pair<String, Episode>, NpcType>().also { map ->
        for (npcType in NpcType.VALUES) {
            if (npcType.episode != null) {
                map[Pair(npcType.simpleName, npcType.episode)] = npcType
                map[Pair(npcType.ultimateName, npcType.episode)] = npcType
            }
        }
    }

/**
 * Uniquely identifies an NPC. Tries to match on [NpcType.simpleName] and [NpcType.ultimateName].
 */
fun NpcType.Companion.fromNameAndEpisode(name: String, episode: Episode): NpcType? =
    EP_AND_NAME_TO_NPC_TYPE[Pair(name, episode)]

/**
 * Display name honoring the Ultimate-difficulty rename. NPCs that are renamed on Ultimate (e.g.
 * Dubchic → Dubchich, Sinow Beat → Sinow Blue) return their [NpcType.ultimateName] when [ultimate]
 * is true; everything else — objects, and NPCs without a distinct Ultimate name — falls back to
 * [EntityType.simpleName].
 */
fun EntityType.displayName(ultimate: Boolean): String =
    if (ultimate && this is NpcType) ultimateName else simpleName
